import { LitElement } from "lit";
import { signalService } from '../services/SignalService';
import { filter } from 'rxjs';
import { property } from 'lit/decorators.js';

type Constructor<T = {}> = new (...args: any[]) => T;

export interface Refreshable extends LitElement {
  refresh(): void;
  id: string;
}

export const RefreshSignalMixin = <TBase extends Constructor<Refreshable>>(Base: TBase) => {
  class RefreshableClass extends Base {
    private _refreshSignal = '';
    private _refreshSignalUnsub = () => {};

    @property({ type: String, attribute: "refresh-signal" })
    get refreshSignal() {
      return this._refreshSignal;
    }
    set refreshSignal(value: string) {
      this._refreshSignal = value;
      this._refreshSignalUnsub();
      if (!value){
        console.warn(`refreshSignalMixin: refresh-signal value is not set, cannot subscribe to signal`, this)
        return
      }
      this._refreshSignalUnsub = signalService.on('refresh-signal')
      .pipe(filter(sp => sp.payload.target === value))
      .subscribe(this.refresh.bind(this)).unsubscribe;
    }
  }
  return RefreshableClass as Constructor<LitElement> & TBase
}